import React, { useState, useEffect } from 'react';
import NavigationBar from '../NavigationBar';
import axios from '../axios';
import { Container, Row, Col, Table, Button, Form, Nav, Modal, Badge } from 'react-bootstrap';

function PurchaseStock() {
    const [tab, setTab] = useState('direct');

    // Direct (reuses the existing StockRolls/StockSummary tables)
    const [directData, setDirectData] = useState([]);
    const [directPage, setDirectPage] = useState(1);
    const [directTotalPages, setDirectTotalPages] = useState(1);

    // Indirect
    const [indirectData, setIndirectData] = useState([]);
    const [showIssue, setShowIssue] = useState(false);
    const [issueForm, setIssueForm] = useState({ materialId: null, materialName: '', qty: '', note: '' });

    useEffect(() => { if (tab === 'direct') fetchDirect(directPage); }, [tab, directPage]);
    useEffect(() => { if (tab === 'indirect') fetchIndirect(); }, [tab]);

    const fetchDirect = async (page) => {
        try {
            const res = await axios.get(`${window.backendUrl}/get_stock_summary`, { params: { page } });
            setDirectData(res.data.data || []);
            setDirectTotalPages(res.data.totalPages || 1);
        } catch (err) { console.error(err); }
    };

    const fetchIndirect = async () => {
        try {
            const res = await axios.get(`${window.backendUrl}/purchase_stock/indirect`);
            setIndirectData(res.data.data || []);
        } catch (err) { console.error(err); }
    };

    const openIssue = (m) => {
        setIssueForm({ materialId: m.MaterialID, materialName: m.Name, qty: '', note: '' });
        setShowIssue(true);
    };

    const handleIssue = async () => {
        if (!issueForm.qty) return;
        try {
            await axios.post(`${window.backendUrl}/purchase_stock/indirect/issue`, {
                materialId: issueForm.materialId, qty: issueForm.qty, note: issueForm.note,
            });
            setShowIssue(false);
            fetchIndirect();
        } catch (err) { console.error(err); alert('Failed to issue stock'); }
    };

    return (
        <>
            <NavigationBar />
            <Container fluid style={{ marginTop: 20, marginBottom: 40 }}>
                <Row className="mb-3"><Col><h3>Purchase Stock</h3></Col></Row>
                <Nav variant="tabs" activeKey={tab} onSelect={k => setTab(k)} className="mb-3">
                    <Nav.Item><Nav.Link eventKey="direct">Direct (Paper)</Nav.Link></Nav.Item>
                    <Nav.Item><Nav.Link eventKey="indirect">Indirect (Other Materials)</Nav.Link></Nav.Item>
                </Nav>

                {tab === 'direct' && (
                    <>
                        <Table striped bordered hover responsive size="sm">
                            <thead>
                                <tr><th>Paper</th><th>Roll size</th><th>Rolls</th><th>Total weight (kg)</th><th>Avg rate</th><th>Total value</th></tr>
                            </thead>
                            <tbody>
                                {directData.length === 0 ? (
                                    <tr><td colSpan={6} className="text-center text-muted" style={{ padding: 20 }}>No direct stock yet.</td></tr>
                                ) : directData.map(row => (
                                    <tr key={row.SummaryID}>
                                        <td>{row.paperName}</td>
                                        <td>{row.RollSize}</td>
                                        <td>{row.TotalRolls}</td>
                                        <td>{Number(row.TotalWeight).toLocaleString()}</td>
                                        <td>{Number(row.AverageRate).toFixed(2)}</td>
                                        <td>{Number(row.TotalValue).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                        <Row>
                            <Col className="d-flex justify-content-center gap-2">
                                <Button size="sm" disabled={directPage <= 1} onClick={() => setDirectPage(p => p - 1)}>Previous</Button>
                                <span className="align-self-center">Page {directPage} of {directTotalPages}</span>
                                <Button size="sm" disabled={directPage >= directTotalPages} onClick={() => setDirectPage(p => p + 1)}>Next</Button>
                            </Col>
                        </Row>
                    </>
                )}

                {tab === 'indirect' && (
                    <Table striped bordered hover responsive size="sm">
                        <thead>
                            <tr><th>Material</th><th>Category</th><th>Balance</th><th>Unit</th><th>Min stock</th><th></th></tr>
                        </thead>
                        <tbody>
                            {indirectData.length === 0 ? (
                                <tr><td colSpan={6} className="text-center text-muted" style={{ padding: 20 }}>No indirect materials yet — add some under Purchase &gt; Indirect Materials.</td></tr>
                            ) : indirectData.map(m => (
                                <tr key={m.MaterialID}>
                                    <td>{m.Name}</td>
                                    <td>{m.Category || '-'}</td>
                                    <td>
                                        {Number(m.BalanceQty).toLocaleString()}
                                        {m.MinStockQty && Number(m.BalanceQty) < Number(m.MinStockQty) && (
                                            <Badge bg="danger" className="ms-2">Low</Badge>
                                        )}
                                    </td>
                                    <td>{m.UnitName}</td>
                                    <td>{m.MinStockQty ?? '-'}</td>
                                    <td><Button size="sm" variant="outline-primary" onClick={() => openIssue(m)}>Issue</Button></td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Container>

            <Modal show={showIssue} onHide={() => setShowIssue(false)} centered>
                <Modal.Header closeButton><Modal.Title>Issue {issueForm.materialName}</Modal.Title></Modal.Header>
                <Modal.Body>
                    <Form.Group className="mb-2">
                        <Form.Label>Quantity</Form.Label>
                        <Form.Control type="number" value={issueForm.qty} onChange={e => setIssueForm({ ...issueForm, qty: e.target.value })} />
                    </Form.Group>
                    <Form.Group className="mb-2">
                        <Form.Label>Note</Form.Label>
                        <Form.Control value={issueForm.note} onChange={e => setIssueForm({ ...issueForm, note: e.target.value })} placeholder="e.g. Issued to printing section" />
                    </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowIssue(false)}>Cancel</Button>
                    <Button variant="primary" onClick={handleIssue}>Issue</Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default PurchaseStock;
